<template>
<div id="app">
  <cookies />
  <dropdown-modal :title="this.$t('signup.reminder')" :active.sync="bioModalActive">
    <div>
      <div class="monkey">
        <h1>🙈</h1>
      </div>
      <p>{{this.$t('signup.yourCompany')}}</p>
      <button class="w-100 button is-primary" @click="bioHandler">{{this.$t('signup.updateCompany')}}</button>
    </div>
  </dropdown-modal>
  <navbar v-if="!hidesNavbar" />
  <div class="page-wrapper">
    <div v-if="!widgetMode" class="sidebar-primary has-background-white " :class="[expanded ? 'sidebar-expanded ':'', isGuest ? '': 'sidebar-user']">
      <sidebar-nav v-on:toggle-expend="onToggleExpand" :expanded="expanded" />
    </div>
    <div class="content-area p0" :class="[!widgetMode && expanded ? 'content-area-expanded' : '',  isGuest ? '': 'content-user', widgetMode ? 'content-area-widget' : '',this.paddingZero && 'p0']">
      <ai-banner v-if="isJobsPage"></ai-banner>
      <div  class="mb-2"></div>
      <router-view />
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Navbar from '@/components/navbar/navbar'
import Cookies from '@/components/general/cookies'
import SidebarNav from '@/components/navbar/sidebar-nav'
import {getUser, userSession} from '@/helpers/stack-auth'
import Wallet from '@/api/wallet'
import Companies from '@/api/companies'
import DropdownModal from '@/components/dropdown-modal'
import {MUNDO_CRYPTO} from './constants/jobboards-ids'
import axios from 'axios'
import errorHandler from './api/error-handler'
import AiBanner from './components/jobs/al-banner.vue'

export default {
  name: 'App',
  components: { AiBanner, Navbar, Cookies, SidebarNav, DropdownModal },
  data () {
    return {
      expanded: true,
      bioModalActive: false,
      pathName: ''
    }
  },
  computed: {
    ...mapState('users', ['user']),
    ...mapState('wallet', ['loginToken']),
    ...mapState('companies', ['company']),
    ...mapGetters('wallet', ['getActiveToken']),
    ...mapState('widgetStyles', ['button', 'activeNav']),
    enableIntercom () {
      return !this.$route.meta.disableIntercom
    },
    hidesNavbar () {
      // return this.$route.meta.hidesNavbar || false
      return true
    },
    widgetMode () {
      return this.$route.meta.widgetMode || false
    },
    isGuest () {
      if (!this.user) {
        return true
      }
      return false
    },
    paddingZero () {
      return this.$route.path === '/jobseekers'
    },
    isJobsPage () {
      return this.pathName.includes('/jobs/all/')
    }
  },
  async created () {
    if (this.enableIntercom) {
      this.$intercom.boot({
        name: 'Guest',
        custom_launcher_selector: '.open_intercom'
      })
    }
  },
  updated () {
    this.pathName = window.location.pathname
    // set mundo crypto jobboard background color
    try {
      const url = window.location.href
      if (url.split('/')[url.split('/').length - 1] === MUNDO_CRYPTO) {
        document.getElementById('body').style.backgroundColor = '#191B1D'
      }
    } catch (e) {
    }

    if (this.user) {
      axios.get(`/api/accounts/profile`).then(r => {
        if (!r.data.completed) {
          this.$router.push('/signup-type')
        }
        return r
      }).catch(errorHandler)
    }
  },

  async mounted () {
    // set mundo crypto jobboard background color
    this.pathName = window.location.pathname
    try {
      const url = window.location.href
      if (url.split('/')[url.split('/').length - 1] === MUNDO_CRYPTO) {
        document.getElementById('body').style.backgroundColor = '#191B1D'
      }
    } catch (e) {
    }

    await this.getStatuses()
    await this.getLinkedEOSAccount()
    this.getJobBoards()
    this.$store.dispatch('wallet/fetchSupportedTokensBalance')

    const walletCheck = await Wallet.getWalletStatus()

    if (walletCheck.confirmedByEmail) {
      if (userSession.isSignInPending()) {
        userSession.handlePendingSignIn().then(userData => {
          window.history.replaceState({}, document.title, '/')
        })
      } else if (userSession.isUserSignedIn()) {
        const userData = userSession.loadUserData()
        const user = getUser()
        if (this.user) {
          this.$store.dispatch('wallet/getStackWalletStatus')
          this.connectStack({userData, user})
        } else {
          userSession.signUserOut()
          this.disconnectStack()
        }
      }
    }

    if (this.user.profile === 'hirer' && this.user.companyId) {
      const companyDetails = await Companies.getDetail(this.user.companyId)
      if (!companyDetails[0].bio) {
        this.bioModalActive = true
      }
    }

    if (this.user) {
      axios.get(`/api/accounts/profile`).then(r => {
        if (!r.data.completed) {
          this.$router.push('/signup-type')
        }
        return r
      }).catch(errorHandler)
    }

    // load resizer script
    const resizerScript = document.createElement('script')
    resizerScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/iframe-resizer@4.3.1/js/iframeResizer.contentWindow.min.js')
    document.body.appendChild(resizerScript)
  },
  methods: {
    ...mapActions('statuses', ['getStatuses']),
    ...mapActions('wallet', ['getLinkedEOSAccount']),
    ...mapActions('jobs', ['getJobBoards']),
    ...mapActions('companies', ['getCompany']),
    ...mapActions('wallet', [
      'connectStack', 'disconnectStack'
    ]),
    onToggleExpand () {
      this.expanded = !this.expanded
    },
    bioHandler () {
      this.bioModalActive = false
      this.$router.push('/signup/hirer')
    }
  },
  sockets: {
    connectionPing () {
      // this.$socket.emit('connectionPong')
    }
  },
  watch: {
    async $route (route) {
      this.$ga.page(route.fullPath)
      if (
        this.$route.meta.authType !== 'unauth' &&
        this.$route.meta.authType !== 'any'
      ) {
        await this.getStatuses()
      }
      window.Intercom('update')
    }
  }
}
</script>

<style lang="css">
.mun-dark{
  background: #191B1D !important;
}

.mun-light{
  color: white !important;
}
</style>

<style lang="scss">
@import "~@/styles/defaults.scss";
.p0{
  padding: 0 !important;
}

html.has-navbar-fixed-top {
  padding-top: 0;
  body {
    line-height: normal;
  }
}
.page-wrapper {
  display: flex;
  .sidebar-primary {
    position: relative;
    width: $sidebar-width-close;
    min-width: $sidebar-width-close;

    &.sidebar-user {
      width: $sidebar-width-non-guest;
      min-width: $sidebar-width-non-guest;
    }
    &.sidebar-expanded {
      min-width: $sidebar-width;
      width: $sidebar-width;
    }
  }
  .content-area {
    position: relative;
    padding-top: 24px;
    width: calc(100% - #{$sidebar-width-close});

    &.content-user {
      width: calc(100% - #{$sidebar-width-non-guest});
    }
    &.content-area-expanded {
      width: calc(100% - #{$sidebar-width});
    }

    &-widget {
      width: 100% !important;
      padding-top: 0;
    }
  }
}
a:hover {
  text-decoration: underline;
}

.button.is-primary:hover {
  background-color: $primary-hover;
}

.field .control {
  margin-top: 0.5rem;
}
body {
  padding-bottom: 1rem;
}

@media screen and (max-width: $desktop) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
    width: auto !important;
    max-width: auto !important;
  }
}

.input select,
.select select,
.select:not(.is-multiple) select,
.textarea select {
  font-size: 0.875rem;
}

.button {
  text-align: center;
  justify-content: center;
}

@media screen and (max-width: $desktop) {
  .container {
    padding-left: 1rem;
    padding-right: 1rem;
    width: auto !important;
    max-width: auto !important;
  }
}

.monkey{
  display: flex; justify-content: center
}

.w-100{
  width: 100%
}
.mb-2{
  margin-bottom: 20px;
}

@media screen and (max-width: $tablet) {
  .page-wrapper {
    flex-direction: column;
    .sidebar-primary {
      width: 100% !important;
      min-width: 100% !important;
      z-index: 5;
    }
    .content-area {
      width: 100% !important;
      margin-top: 72px;

      &-widget {
        margin: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue